module.exports = __webpack_public_path__ + "static/media/integrity.3978139b.png";